import { createFileRoute } from "@tanstack/react-router";
import { AdminLayout } from "@/components/admin/AdminLayout";
import { EmailInbox } from "@/components/admin/email/EmailInbox";

export const Route = createFileRoute("/_authenticated/admin/email/")({
  head: () => ({
    meta: [
      { title: "Админ — Имейл | FIXHEN" },
      { name: "description", content: "Клиентска кореспонденция и прикачени файлове в FIXHEN." },
      { property: "og:title", content: "Имейл — FIXHEN администрация" },
      { property: "og:description", content: "Клиентска кореспонденция и прикачени файлове в FIXHEN." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <AdminLayout>
      <EmailInbox />
    </AdminLayout>
  ),
});
